import React from 'react';
import ReactDOM from 'react-dom/client';
import UserProfileCard from './UserProfileCard';
import { AuthenticationProvider } from '../context/AuthenticationContext';
import MyAccountCard from '../components/MyAccountCard';
import MyProjectsList from '../my-projects/MyProjectsList';
import MyDistributorsCarousel from '../distributors/MyDistributorsCarousel';
import MySalesOffice from '../sales-office/MySalesOffice';
import ToastNotification from '../components/toast/ToastNotification';
import { dashboardPaths } from '../data';

const $root: HTMLElement | null = document.getElementById(
	'timken-my-dashboard-dashboard',
);

if ($root) {
	const salesOfficeUrl = window?._timken?.salesOfficeUrl as string ?? 'https://locations.timken.com/sales-locator/';
	const distributorUrl = window?._timken?.distributorUrl as string ?? 'https://locations.timken.com/distributor-locator/';

	ReactDOM.createRoot($root).render(
		<React.StrictMode>
			<AuthenticationProvider>
				<UserProfileCard />

				<MyAccountCard title='My Projects' link={dashboardPaths.projects} linkText='View all' alternate={true}>
					<MyProjectsList preview={true} limit={4} />
				</MyAccountCard>

				<MyAccountCard
					alternate={true}
					customClass='t-my-dashboard__card--distributors'
					externalLink={true}
					id="my-distributors"
					link={distributorUrl}
					linkText="View all"
					title="My Distributors"
				>
					<MyDistributorsCarousel />
				</MyAccountCard>

				<MyAccountCard
					alternate={true}
					customClass='t-my-dashboard__card--sales'
					externalLink={true}
					id="my-sales-office"
					link={salesOfficeUrl}
					linkText="View all"
					title="My Sales Office"
				>
					<div className="t-my-dashboard__card__content__item">
						<MySalesOffice />
					</div>
				</MyAccountCard>

				<ToastNotification />
			</AuthenticationProvider>
		</React.StrictMode>
	);
}
